module.exports = __webpack_public_path__ + "img/denmark-congenital-and-perinatal-diseases-male.5dd27851.png";